import React from "react";
import './informatique.css';
import infrastructureimg from './infrastructure.png';
import VideoPresentationInformatique from "./video_presentation_informatique.mp4";
import VideoPresentationInformatiquePoster from "./video_presentation_informatique_poster.png";
import MaterielImg from '../../components/Ordinateur/Pc_Portable.png';
import infogeranceimg from './Infogerence.png';
import SauvegardeImg from './Sauvegarde.png';
import SEO from "../../Hook/Seo";
import { useNavigate } from "react-router-dom";
import BreadcrumbsSchema from "../../Hook/BreadcrumbsSchema";

const Informatique = () => {
  const navigate = useNavigate();

  return (
    <>
      <SEO
        title="Maintenance & Infogérance informatique dans les Vosges | AM Services"
        description="Support postes/serveurs, sauvegardes, sécurité, Wi-Fi et réseaux pour PME dans les Vosges."
        path="/informatique"
      />
      <BreadcrumbsSchema />
      
      {/* 1. L'ACCUEIL VIDÉO PUR PLEIN ÉCRAN */}
      <div className="info-hero-container">
        <div className="info-video-wrapper">
          <video src={VideoPresentationInformatique} poster = {VideoPresentationInformatiquePoster} autoPlay muted loop preload="auto" playsInline className="info-background-video" />
          <div className="info-hero-overlay"></div>
        </div>

        <div className="info-hero-center-text">
          <h1 className="info-title">SERVICES INFORMATIQUES</h1>
          <p className="info-lead">
            Des solutions robustes, managées et sécurisées de bout en bout.
          </p>
        </div>

        <div className="scroll-indicator" onClick={() => document.getElementById('expertises-content').scrollIntoView({ behavior: 'smooth' })}>
          <span className="arrow"></span>
        </div>
      </div>

      {/* 2. LE CONTENU BIEN PROPRE ET NEUF EN DEHORS DE LA VIDÉO */}
      <div className="info-showcase-section" id="expertises-content">
        <div className="section-intro-text">
          <h2>Découvrez nos expertises métiers</h2>
          <div className="info-accent-line"></div>
        </div>

        <div className="expertises-layouts-container">
          
          {/* BLOC 1 : MATÉRIEL (IMAGE À GAUCHE, TEXTE À DROITE) */}
          <section className="expertise-row-card">
            <div className="expertise-image-side">
              <img src={MaterielImg} alt="Matériel et Vente" className="premium-showcase-img" />
            </div>
            <div className="expertise-text-side">
              <span className="row-tag">Équipements</span>
              <h3>Matériel et Vente</h3>
              <p>
                Nous sélectionnons et configurons le meilleur du matériel professionnel en partenariat avec les plus grandes marques. PC portables, stations fixes, serveurs d'entreprise, architectures NAS et solutions spécifiques pour le secteur médical.
              </p>
              <button className="btn-expertise-action" onClick={() => navigate("/ordinateur")}>
                Découvrir l'offre
              </button>
            </div>
          </section>

          {/* BLOC 2 : INFOGÉRANCE (TEXTE À GAUCHE, IMAGE À DROITE) */}
          <section className="expertise-row-card reverse-row">
            <div className="expertise-text-side">
              <span className="row-tag">Maintenance</span>
              <h3>Infogérance & Maintenance</h3>
              <p>
                Garantissez la continuité de votre activité grâce à notre système de supervision active. Nous veillons sur vos parcs informatiques au quotidien : fiabilité, correctifs de sécurité, optimisation des performances et interventions rapides.
              </p>
              <button className="btn-expertise-action" onClick={() => navigate("/infogerance")}>
                Découvrir l'offre
              </button>
            </div>
            <div className="expertise-image-side">
              <img src={infogeranceimg} alt="Infogérance" className="premium-showcase-img" />
            </div>
          </section>

          {/* BLOC 3 : RÉSEAUX (IMAGE À GAUCHE, TEXTE À DROITE) */}
          <section className="expertise-row-card">
            <div className="expertise-image-side">
              <img src={infrastructureimg} alt="Infrastructure & Réseaux" className="premium-showcase-img" />
            </div>
            <div className="expertise-text-side">
              <span className="row-tag">Réseaux</span>
              <h3>Infrastructure & Réseaux</h3>
              <p>
                Propulsez votre entreprise avec un réseau local et distant stable, performant et hautement sécurisé. Conception d'architectures LAN/WAN, routage avancé, déploiement Wi-Fi professionnel et administration de switchs managés.
              </p>
              <button className="btn-expertise-action" onClick={() => navigate("/infrastructure")}>
                Découvrir l'offre
              </button>
            </div>
          </section>

          {/* BLOC 4 : SAUVEGARDE (TEXTE À GAUCHE, IMAGE À DROITE) */}
          <section className="expertise-row-card reverse-row">
            <div className="expertise-text-side">
              <span className="row-tag">Sécurité</span>
              <h3>Sauvegarde Managée</h3>
              <p>
                Protégez votre patrimoine numérique contre les ransomwares et les pannes matérielles. Nos solutions de sauvegarde automatisées intègrent un chiffrement de bout en bout, une redondance multi-sites et un contrôle de traçabilité strict.
              </p>
              <button className="btn-expertise-action" onClick={() => navigate("/sauvegarde")}>
                Découvrir l'offre
              </button>
            </div>
            <div className="expertise-image-side">
              <img src={SauvegardeImg} alt="Sauvegarde" className="premium-showcase-img" />
            </div>
          </section>

        </div>
      </div>
    </>
  );
};

export default Informatique;